"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = require("vue");
var _antDesignVue = require("ant-design-vue");
var _SubjectEditModal = _interopRequireDefault(require("./SubjectEditModal"));
var _CellStyleModal = _interopRequireDefault(require("./CellStyleModal"));
var _useReportSubjectEditor = require("./useReportSubjectEditor");
var _sortablejs = _interopRequireDefault(require("sortablejs"));
// https://www.itxst.com/sortablejs/neuinffi.html

// 自定义单元格样式-背景色、字重
const cellStyle = record => {
  const style = record.style || {};
  return {
    ...style,
    backgroundColor: `${style.backgroundColor || 'inherit'} !important`,
    fontWeight: style.fontWeight
  };
};
var _default = exports.default = {
  name: 'ReportSubjectEditor',
  // 智能报表-添加科目组件
  components: {
    SubjectEditModal: _SubjectEditModal.default,
    CellStyleModal: _CellStyleModal.default
  },
  props: {
    // json字符串
    value: {
      type: String,
      default: ''
    },
    // 统计维度，Shop：店铺，Anchor：主播，Sku：单品
    dimension: {
      type: String,
      default: undefined,
      validator: value => ['Shop', 'Anchor', 'Sku'].includes(value)
    },
    // 业务类型，Report：智能报表，Card：卡片，Chart1：柱状图，Chart2：折线图
    bizType: {
      type: String,
      default: 'Report',
      validator: value => ['Report', 'Card', 'Chart1', 'Chart2'].includes(value)
    },
    // 来源，Personal：个人模板，Common：公共模板，该值为Personal时，type只能为Dynamic
    source: {
      type: String,
      default: 'Common',
      validator: value => ['Personal', 'Common'].includes(value)
    },
    // 模板类型，Static：利润报表，Dynamic：实时业绩报表
    type: {
      type: String,
      default: 'Static',
      validator: value => ['Static', 'Dynamic'].includes(value)
    },
    // 最多能添加的一级科目数量，0表示不限制
    limit: {
      type: Number,
      default: 0
    },
    // 添加按钮后面的提示语
    desc: {
      type: String,
      default: undefined
    },
    scroll: {
      type: Object,
      default: () => {
        return {
          x: false,
          y: false
        };
      }
    },
    // 是否显示“选择已有公式科目”入口
    showSelectFormulaEntry: {
      type: Boolean,
      default: true
    }
  },
  provide() {
    return {
      dimension: (0, _vue.computed)(() => this.dimension),
      bizType: (0, _vue.computed)(() => this.bizType),
      source: (0, _vue.computed)(() => this.source),
      type: (0, _vue.computed)(() => this.type),
      dataSource: (0, _vue.computed)(() => this.dataSource),
      showSelectFormulaEntry: (0, _vue.computed)(() => this.showSelectFormulaEntry)
    };
  },
  data() {
    return {
      ROOT_ID: _useReportSubjectEditor.ROOT_ID,
      dataList: [],
      // 平级数据
      dataSource: [],
      // 树结构
      columns: [{
        title: '科目名称',
        dataIndex: 'name',
        customCell: record => ({
          style: cellStyle(record)
        }),
        filterable: true
      }, {
        title: '科目类型',
        dataIndex: 'type',
        customRender: (text, record) => (0, _useReportSubjectEditor.getSubjectType)(record.type, record.statType).text,
        customCell: record => {
          return {
            class: (0, _useReportSubjectEditor.getSubjectType)(record.type, record.statType).color,
            style: cellStyle(record)
          };
        }
      }, {
        title: '操作',
        key: 'operation',
        width: 300,
        scopedSlots: {
          customRender: 'operation'
        },
        customCell: record => ({
          style: cellStyle(record)
        })
      }]
    };
  },
  computed: {
    // 默认打开第一层
    defaultExpandedRowKeys() {
      return this.dataSource.map(item => item.id);
    }
  },
  watch: {
    value: {
      handler(val) {
        if (this.$m.test.isJsonString(val)) {
          this.dataSource = JSON.parse(val);
          this.dataList = this.$m.tree.toList(_.cloneDeep(this.dataSource));
        } else {
          this.dataSource = [];
        }
      },
      immediate: true,
      deep: true
    },
    dataSource: {
      handler(val, oldVal) {
        // 初始化时不触发表单校验
        if (oldVal !== undefined) {
          const res = !_.isEmpty(val) ? JSON.stringify(val) : undefined;
          this.$emit('input', res);
          this.$emit('change', res);
        }
        this.$nextTick(() => {
          if (val && val.length > 0) this.rowDrop();
        });
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 表格本地操作逻辑 Begin
    /**
     * @description: 点击操作按钮
     * @param {String} operate delete删除 add添加科目 add-child添加子科目 edit编辑 custom-cell-style自定义单元格样式属性
     * @param {Object|undefined} record 当前点击的行
     * @param {Number|undefined} index 当前点击行的索引
     */
    handleOperate(operate, record, index) {
      if (operate === 'delete') {
        this.$m.tree.removeNode(this.dataSource, node => node.id === record.id);
        this.dataSource.splice(index, 0);
      } else if (['add', 'add-child', 'edit'].includes(operate)) {
        this.$refs.subjectEditModal.open({
          operate,
          record,
          index
        });
      } else if (operate === 'custom-cell-style') {
        this.$refs.cellStyleModal.open({
          record,
          index
        });
      }
    },
    /**
     * @description: 更新“SubjectEditModal”编辑的数据到报表模板中
     * @param {string} operate add添加科目 add-child添加子科目 edit编辑
     * @param {object} node 需要更新或插入的节点
     * @param {number} index 当前操作的索引
     */
    insertSubject(operate, node, index) {
      const {
        limit,
        dataSource
      } = this;
      if (operate === 'add' && limit !== 0 && dataSource.length >= limit) {
        _antDesignVue.message.warning({
          key: 'limit',
          content: `当前模块要求一级科目不能超过${limit}个，超出部分已被自动去除`
        });
        this.$refs.subjectEditModal.close();
        return;
      }
      const parent = this.$m.tree.findNode(dataSource, _node => _node.id === node.pid);
      const target = parent ? parent.children : dataSource;
      if (operate === 'edit') {
        target.splice(index, 1, node);
      } else if (operate === 'add') {
        target.splice(index, 0, node);
      } else if (operate === 'add-child') {
        // 使用 this.$set 解决对象新增属性无法触发视图更新的问题
        if (!parent.children) this.$set(parent, 'children', []);
        parent.children.splice(parent.children.length, 0, node);
      }
      this.$refs.subjectEditModal.close();
    },
    /**
     * @description: 更新“CellStyleModal”编辑的数据到报表模板中
     * @param {object} node 需要更新或插入的节点
     * @param {number} index 当前操作的索引
     */
    handleCellStyleOk(node, index) {
      const parent = this.$m.tree.findNode(this.dataSource, _node => _node.id === node.pid);
      const target = parent ? parent.children : this.dataSource;
      target.splice(index, 1, node);
    },
    // 行拖拽
    rowDrop() {
      const tbody = this.$refs.Scheduling.querySelectorAll('.ant-table-tbody'); // 元素选择器名称根据实际内容替换
      if (!tbody) return;
      const _this = this;
      _sortablejs.default.create(tbody[0], {
        animation: 150,
        sort: true,
        handle: '.dragSort',
        // 指定哪个类名的可以拖动
        chosenClass: 'sortable-chosen',
        // 被选中项的css 类名
        dragClass: 'sortable-drag',
        // 正在被拖拽中的css类名
        ghostClass: 'sortable-ghost',
        // 拖拽移动的时候
        onMove({
          dragged,
          related
        }) {
          // 树数据中不管是哪一层，都一定要有_level字段表示当前是第几层
          /*
            evt.dragged; // 被拖拽的对象
            evt.related; // 被替换的对象
          */
          const dataList = _.cloneDeep(_this.dataList);
          const oldRow = dataList[dragged.rowIndex - 1];
          const newRow = dataList[related.rowIndex - 1];
          if (oldRow.id === newRow.pid) {
            return false;
          }
          return true;
        },
        onEnd: async ({
          oldIndex,
          newIndex
        }) => {
          const dataList = _.cloneDeep(_this.dataList);
          const oldRow = dataList[oldIndex];
          const newRow = dataList[newIndex];
          if (oldIndex !== newIndex) {
            // 跨级拖拽 oldRow.id === newRow.pid => 父节点拖拽到子节点  oldRow.pid === newRow.pid => 同一个父节点（同级）
            if (oldRow.pid !== newRow.pid && oldRow.id !== newRow.pid) {
              // 移除旧值
              const parent = dataList.find(item => item.id === oldRow.pid) || {};
              if (parent.children) {
                const index = parent.children.findIndex(item => item.id === oldRow.id);
                parent.children.splice(index, 1);
              }
              // 变更父节点和层级
              oldRow.pid = newRow.pid;
              oldRow._level = newRow._level;
            }

            // 把源数据拖动到目标数据之上，其他数据按顺序下移
            dataList.splice(oldIndex, 1);
            dataList.splice(newIndex, 0, oldRow);
            _this.dataList = dataList;

            // 先清空后赋值，确保table能触发重新渲染，否则树形结构时会出现错乱的问题
            _this.dataSource = [];
            this.$nextTick(() => {
              _this.dataSource = this.$m.tree.toTree(dataList);
            });
          }
        }
      });
    }
    // 表格本地操作逻辑 End
  }
};